/* 夏侯淵傳・第 4 章：長離・興國（建安十九年，214）
 * 史實：《三國志·夏侯淵傳》「淵收遂軍糧，追至略陽城，去遂二十餘里，諸將欲攻之，或言當攻興國氐。淵以爲遂兵精，興國城固，攻不可卒拔，
 *       不如擊長離諸羌。長離諸羌多在遂軍，必歸救其家。……淵乃留督將守輜重，輕兵步騎到長離，攻燒羌屯，斬获甚眾。諸羌在遂軍者，各還種落。
 *       遂果救長離，與淵軍對陣。諸將見遂眾，惡之，欲結營作塹乃與戰。淵曰：『我轉鬭千里，今復作營塹，則士眾罷弊，不可久。賊雖眾，易與耳。』
 *       乃鼓之，大破遂軍，得其旌麾，還略陽，進軍圍興國。氐王千萬逃奔馬超，餘眾降。」
 * 流程：1. 輜重留在略陽營，出營就是輕兵（跑得快）。興國城門打不開；韓遂大營兵精。往西燒長離的四座羌屯：
 *          每燒一屯，韓遂軍裡那一部羌兵就離開韓遂、跑回去救家（路上不打仗，到了就散回種落）。
 *       2. 四屯燒完（或時間到），韓遂帶剩下的兵來救，兩軍對陣。去「結營作塹」部下會罷弊；對陣 15 秒內出手就是「乃鼓之」。
 *       3. 韓遂被打到四成棄旗逃走，得其旌麾；旁白：圍興國、氐王千萬逃奔馬超。 */
// @ts-nocheck
import { SG } from '../../core/sg.ts';
import { setLevel, boss, rout, vanish, TROOPS } from '../kit.ts';
import { XHY, XTROOPS, F, campDraw } from './xiahouyuan_kit.ts';
import { CAMP, HAN, XG_GATE, QIANG, FIELD, DITCH } from '../maps/xiahouyuan_changli.ts';

const LV = 12, COME = 170, DRUM = 15;
const QB = F(XTROOPS.qiang, '羌兵', 420, 22, 255), LB = F(XTROOPS.liang, '涼州兵', 460, 22, 245), GUARD = F(XTROOPS.qiang, '羌兵', 360, 20, 240);
const QN = ['燒當羌', '先零羌', '罕羌', '開羌']; // 只是區分四部的名字（史書沒寫長離諸羌是哪幾種）

export default {
  id: 'xiahouyuan-4', map: 'xiahouyuan_changli', hero: 'xiahouyuan',
  title: '第 4 章　長離・興國', year: '建安十九年（214）',
  brief: {
    quote: [{ text: '長離諸羌多在遂軍，必歸救其家。', src: '《三國志·魏書·夏侯淵傳》' }],
    text: '解了祁山之圍，夏侯淵追韓遂到略陽。諸將有的要攻韓遂，有的要攻興國的氐人。夏侯淵認為韓遂兵精、興國城固，都不能很快拿下，決定去燒長離的羌屯，逼韓遂軍裡的羌兵回去救家。',
    goals: ['輜重留在營裡，輕兵往西去長離', '燒掉四座羌屯，讓韓遂軍裡的羌兵各還種落', '韓遂來救：不必結營，擂鼓進攻'],
  },
  words: { ally: '魏軍', foe: '韓遂軍' },
  stars: [
    { text: '韓遂來救之前四座羌屯都燒了', ok: (m) => !!m.vars.allBurnt },
    { text: '如史：不結營，對陣 15 秒內擂鼓進攻', ok: (m) => !!m.vars.drum && !m.vars.camped },
    { text: '部下折損不超過 4 人', ok: (m) => m.stats.lost <= 4 },
  ],
  steps: [
    { // 1. 燒長離羌屯
      enter(m, w) {
        const me = w.player, V = m.vars;
        setLevel(w, me, LV);
        me.x = CAMP[0] - 200; me.y = CAMP[1];
        V.t0 = w.t; V.burnt = 0;
        me.fireproof = true; // 自己放的火：站在上風處，不會燒到自己人（部下在下面也設）
        V.men = Array.from({ length: 12 }, (_, i) => { const u = m.recruit(me.x - 80 - (i % 4) * 50, me.y - 80 + Math.floor(i / 4) * 80, '輕騎'); u.spec = TROOPS.wei; u.ms = 300; u.fireproof = true; m.join(u, me); return u; });
        [[-160, 120], [0, 180], [160, 120]].forEach(([dx, dy]) => m.folk(CAMP[0] + dx, CAMP[1] + dy, { name: '輜重', still: true, near: 1, draw: SG.campaignDraw.supply }));
        // 韓遂大營：本部涼州兵，加上四部羌兵
        V.han = boss(w, XHY.hansui, HAN[0], HAN[1], { name: '韓遂', hp: 4400, atk: 40, armor: 8, ms: 245 });
        V.base = Array.from({ length: 6 }, (_, i) => m.foe('huangjin', HAN[0] - 300 + (i % 4) * 160, HAN[1] + 220 + Math.floor(i / 4) * 140, LB));
        V.groups = QIANG.map((_, k) => Array.from({ length: 4 }, (_, i) => { const u = m.foe('huangjin', HAN[0] + 400 + (k % 2) * 260, HAN[1] - 300 + Math.floor(k / 2) * 300 + i * 50, QB); u.name = QN[k]; return u; }));
        V.tuns = QIANG.map(([x, y], k) => {
          m.mark('q' + k, x, y, '羌屯', true);
          const f = m.folk(x, y - 40, { name: '羌屯', still: true, near: 1, draw: campDraw, col: '#8a6a4a', flag: '羌', flagCol: '#8a5a2a' });
          const guard = [0, 1, 2].map((i) => m.foe('huangjin', x + (i - 1) * 140, y + 160, GUARD));
          return { k, x, y, f, guard, lit: false };
        });
        m.gate('xg', XG_GATE[0], XG_GATE[1], 170, 'citygate', ['夏侯淵', '興國城固，攻不可卒拔。去長離！']);
        m.card('淵以爲遂兵精，興國城固，攻不可卒拔，不如擊長離諸羌。', '《夏侯淵傳》');
        m.after(5, () => m.card('淵乃留督將守輜重，輕兵步騎到長離。', '《夏侯淵傳》'));
        m.after(8, () => m.line('提示', '離開營地就是輕兵，跑得快。站在羌屯中央不動就能放火。'));
        m.mark('cl', QIANG[3][0], QIANG[3][1], '長離');
        m.obj('burn', '燒長離羌屯', 4);
        m.obj('han', '');
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        light(m, w);
        for (const T of V.tuns) {
          if (T.lit) continue;
          m.chanAt(me, 'q' + T.k, T.x, T.y + 60, 240, 2.5, '放火', () => {
            T.lit = true; T.f.burnt = true; V.burnt++; m.unmark('q' + T.k); m.unmark('cl');
            for (const [dx, dy] of [[0, 0], [-90, 50], [90, 50]]) m.fire(T.x + dx, T.y + dy, { dps: 40, life: 14 });
            // 那一部羌兵離開韓遂，跑回來救家
            for (const u of m.alive(V.groups[T.k])) { u.home = [T.x + (SG.rand() - 0.5) * 300, T.y + 200]; u.ms = 280; u.back = true; u.target = null; }
            m.line(QN[T.k], '家被燒了！回去！回去！');
          });
        }
        m.prog('burn', V.burnt);
        const army = hanArmy(m, V);
        m.get('han').text = `韓遂軍：${army.length} 人`;
        if (V.burnt >= 4) { V.allBurnt = true; return true; }
        return w.t - V.t0 > COME;
      },
    },
    { // 2. 遂果救長離：對陣
      enter(m, w) {
        const V = m.vars;
        m.done('burn');
        m.card('諸羌在遂軍者，各還種落。遂果救長離，與淵軍對陣。', '《夏侯淵傳》');
        V.army = hanArmy(m, V);
        const sp = [FIELD[0] - 200, FIELD[1] - 500];
        V.han.x = sp[0]; V.han.y = sp[1]; V.han.home = sp.slice();
        V.army.forEach((u, i) => { const p = SG.MAP.nearestFree(sp[0] - 360 + (i % 6) * 130, sp[1] + 140 + Math.floor(i / 6) * 110); u.x = p[0]; u.y = p[1]; u.home = p.slice(); u.target = null; });
        m.mark('han', V.han.x, V.han.y, '韓遂', false, V.han);
        m.mark('ditch', DITCH[0], DITCH[1], '結營作塹', true);
        m.obj('face', '大破韓遂軍');
        const pk = w.xPreKill;
        w.xPreKill = function (src, t) { if (t === V.han) { t.hp = 1; return true; } return pk.call(this, src, t); };
      },
      tick(m, w, dt) {
        const me = w.player, V = m.vars;
        light(m, w);
        if (V.faceT == null) {
          if (!m.near(me, FIELD[0], FIELD[1], 900)) return false;
          V.faceT = w.t;
          m.line('部將', '韓遂兵多……是不是先結營作塹，再和他打？');
          m.after(3, () => m.line('提示', `要結營，到「結營作塹」那裡站著；要打，${DRUM} 秒內直接衝上去。`));
        }
        m.chanAt(me, 'ditch', DITCH[0], DITCH[1], 220, 3, '結營作塹', () => {
          V.camped = true; m.unmark('ditch');
          m.line('夏侯淵', '……我轉鬭千里，今復作營塹，則士眾罷弊。');
          for (const u of m.alive(V.men).concat(me)) w.addBuff(u, { id: '罷弊', t: 60, neg: true, atkP: -0.2, ms: -0.1 });
        });
        const hit = V.army.concat(V.han).some((u) => u.dmgBy && Object.keys(u.dmgBy).some((k) => u.dmgBy[k] > V.faceT));
        if (hit && !V.engaged) {
          V.engaged = true; m.unmark('ditch');
          if (!V.camped && w.t - V.faceT <= DRUM) {
            V.drum = true; m.big('賊雖眾，易與耳——擂鼓！');
            for (const u of m.alive(V.men).concat(me)) w.addBuff(u, { id: '鼓之', t: 25, atkP: 0.3, ms: 0.15 });
          }
          for (const u of m.alive(V.army).concat(V.han)) u.home = [me.x, me.y];
        }
        if (!V.engaged && w.t - V.faceT > 20) { V.engaged = true; m.line('韓遂', '夏侯淵不敢動？殺過去！'); for (const u of m.alive(V.army).concat(V.han)) u.home = [me.x, me.y]; }
        if (V.engaged) for (const u of m.alive(V.army).concat(V.han)) if (!(u.target && u.target.alive)) u.home = [me.x, me.y];
        return V.han.hp < V.han.maxHp * 0.4;
      },
    },
    { // 3. 大破遂軍，得其旌麾
      enter(m, w) {
        const V = m.vars;
        m.done('face'); m.unmark('han'); m.unmark('ditch');
        m.loot(V.han.x, V.han.y, 'gold', { n: 200, name: '韓遂旌麾' });
        rout(m, w, m.alive(V.army).concat(V.han), [8800, 300]);
        m.big('韓遂棄旗而走！');
        m.after(3, () => m.card('乃鼓之，大破遂軍，得其旌麾，還略陽，進軍圍興國。', '《夏侯淵傳》'));
        m.after(9, () => { m.ungate('xg'); m.card('氐王千萬逃奔馬超，餘眾降。', '《夏侯淵傳》'); });
        m.after(15, () => m.win());
      },
      tick() { return false; },
    },
  ],
  always(m, w) {
    // 回去救家的羌兵：路上不打仗，到了就散回種落（從場上拿掉）
    for (const g of m.vars.groups) for (const u of g) if (u.back && u.alive) { if (SG.gd(u.x, u.y, u.home[0], u.home[1]) < 160) vanish(w, u); else { u.target = null; u.think = 0.5; } }
    if (!w.player.alive) m.lose('夏侯淵陣亡');
  },
};

// 韓遂現在手上的兵：本部，加上家還沒被燒的羌兵
function hanArmy(m, V) { return m.alive(V.base).concat(...V.groups.filter((_, k) => !V.tuns[k].lit).map((g) => m.alive(g))); }
// 輕兵：離開略陽營（輜重）就跑得快
function light(m, w) {
  const me = w.player;
  if (!m.near(me, CAMP[0], CAMP[1], 700)) for (const u of [me].concat(m.alive(m.vars.men))) { const b = u.buffs && u.buffs.find((o) => o.id === '輕兵'); if (!b || b.t < 0.3) w.addBuff(u, { id: '輕兵', t: 1, ms: 0.2 }); }
}
